export default __webpack_public_path__ + "static/media/3d-casual-life-cloud-storage.be809982.png";